import React from 'react'
import OverviewTable from './OverviewTable'

export default function SalesOverviewTable() {
  return <OverviewTable module="SALES" redirect="sales" />
}
